import { render } from "./SampleDetailsPage.vue?vue&type=template&id=63362851"
import script from "./SampleDetailsPage.vue?vue&type=script&lang=js"
export * from "./SampleDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__